export enum MatchTileStatus {
  Preparing,
  Invited,
  ReadyToPlay,
  Win,
  Lose,
  Tied,
  Forfeit,
  Aborted,
  Default,
}
